import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import GetAccount from './views/Get.vue'

export const AccountRoutes = [
  {
    path: '/ledger-accounts',
    name: 'ListAccounts',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'ledger_account:list'
    }
  },
  {
    path: '/ledger-account',
    name: 'CreateAccount',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'ledger_account:create'
    }
  },
  {
    path: '/ledger-account/:id',
    name: 'UpdateAccount',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'ledger_account:update'
    }
  },
  {
    path: '/ledger-account/view/:id',
    name: 'GetAccount',
    component: GetAccount,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'ledger_account:get'
    }
  }
]
